/**
 * Whether a Clerk error carries one of `codes`, either as its own `code` or in
 * the API response's `errors[].code`. Duck-typed so callers do not pull Clerk's
 * error helpers into eager bundles.
 */
export function hasClerkErrorCode(error: unknown, codes: readonly string[]): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const { code, errors } = error as { code?: unknown; errors?: unknown };
  const matches = (value: unknown) => typeof value === 'string' && codes.includes(value);
  if (matches(code)) return true;
  return (
    Array.isArray(errors) &&
    errors.some(
      (entry) =>
        typeof entry === 'object' && entry !== null && matches((entry as { code?: unknown }).code),
    )
  );
}
